import BaseClass from "../../util/BaseClass";
import Context from "../../context/Context";
import FieldNames from "../../aiim/datasets/FieldNames";
import Topic from "../../context/Topic";
import * as selectionUtil from "../../aiim/util/selectionUtil";
import * as sourceUtil from "./sourceUtil";
import * as val from "../../util/val";

export default class QueryCriteria extends BaseClass {

  filterableFields;
  filterPairs;
  key;
  primarySortField;
  requiredExpression;
  searchText = "";
  sortOptions;
  sourceKey;
  where;

  static get(key,sourceKey) {
    const session = Context.instance.session;
    if (!session.queryCriteriaByKey) session.queryCriteriaByKey = {};
    let queryCriteria = session.queryCriteriaByKey[key];
    if (!queryCriteria) {
      queryCriteria = session.queryCriteriaByKey[key] = new QueryCriteria({
        key: key,
        sourceKey: sourceKey
      });
    }
    return queryCriteria;
  }

  getSource() {
    return sourceUtil.getSourceByKey(this.getSourceKey());
  }

  getSourceKey() {
    return this.sourceKey;
  }

  getWhere() {
    return this.where || "1=1";
  }

  hasFilterPairs() {
    let hasFilter = false;
    const pairs = this.filterPairs;
    if (Array.isArray(pairs) && pairs.length > 0) {
      hasFilter = pairs.some(pair => {
        if (typeof pair.field === "string" && pair.field.length > 0 &&
           pair.value !== undefined) {
          return true;
        }
        return false;
      });
    }
    return hasFilter;
  }

  makeFilterPart(source,pairs,ignoreField) {
    let q, part, parts = "", where = null;
    if (Array.isArray(pairs) && pairs.length > 0) {
      pairs.forEach(pair => {
        if (typeof pair.field === "string" && pair.field.length > 0 &&
           pair.value !== undefined && pair.field !== ignoreField) {
          if (pair.value === null) {
            part = "("+pair.field+" IS NULL)";
          } else {
            if (typeof pair.value === "string") {
              q = "'" + selectionUtil.escSqlQuote(pair.value) + "'";
            } else {
              q = pair.value;
            }
            part = "("+pair.field+" = "+q+")";
          }
          if (parts.length > 0) parts += " AND ";
          parts += "("+part+")";
        }
      })
    }
    if (parts && parts.length > 0) {
      //if (where.length > 0) where += " AND ";
      where = "("+parts+")";
    }
    return where;
  }

  makeLevelFilter(source) {
    let v1, v2, filter;
    const fields = source.getFields();
    const fidField = source.findField(fields,FieldNames.FACILITY_ID,"facilityIdField");
    const voField = source.findField(fields,FieldNames.VERTICAL_ORDER,"verticalOrderField");
    const fm = Context.instance.aiim.facilityMode
    const level = fm && fm.activeFacilityInfo && fm.activeFacilityInfo.activeLevel;

    if (level) {
      v1 = "("+fidField.name+" = '"+selectionUtil.escSqlQuote(level.facilityId)+"')";
      v1 += " AND ("+voField.name+" = "+level.verticalOrder+")";
      v2 = "("+fidField.name+" <> '"+selectionUtil.escSqlQuote(level.facilityId)+"')";
      v2 += " AND ("+voField.name+" = 0)";
      filter = "("+v1+") OR ("+v2+")";
    } else {
      filter = "("+voField.name+" = 0)";
    }
    return filter;
  }

  makeOrderByFields() {
    let orderByField, orderByFields;
    const sortOptions = this.sortOptions;
    const primarySortField= this.primarySortField;
    if (sortOptions && sortOptions.sortBy && sortOptions.sortBy !== "distance") {
      orderByField = sortOptions.sortBy;
      if (sortOptions.sortDir === "desc") orderByField += " DESC";
      orderByFields = [orderByField]
      if (primarySortField &&
          primarySortField.toLowerCase() !== sortOptions.sortBy.toLowerCase()) {
        orderByFields.push(primarySortField)
      }
    } else if (primarySortField) {
      orderByFields = [primarySortField]
    }
    return orderByFields;
  }

  makeWhere(source) {
    let where = "", q, v, part;

    q = this.searchText;
    if (typeof q === "string" && q.length > 0) {
      part = "";
      q = q.toUpperCase();
      q = "'%" + selectionUtil.escSqlQuote(q) + "%'";
      let searchFields = source && source.searchFields;
      if (!searchFields || searchFields.length === 0) {
        if (source.displayField) {
          searchFields = [source.displayField];
        }
      }
      if (Array.isArray(searchFields)) {
        searchFields.forEach(f => {
          v = "(UPPER("+f+") LIKE "+q+")";
          if (part.length > 0) part += " OR ";
          part += v;
        })
      }
      if (part && part.length > 0) {
        if (where.length > 0) where += " AND ";
        where += "("+part+")";
      }
    }

    part = this.makeFilterPart(source,this.filterPairs);
    if (part && part.length > 0) {
      if (where.length > 0) where += " AND ";
      where += "("+part+")";
    }
    // parts = "";
    // const pairs = this.filterPairs;
    // if (Array.isArray(pairs) && pairs.length > 0) {
    //   pairs.forEach(pair => {
    //     if (typeof pair.field === "string" && pair.field.length > 0 &&
    //        pair.value !== undefined) {
    //       if (pair.value === null) {
    //         part = "("+pair.field+" IS NULL)";
    //       } else {
    //         if (typeof pair.value === "string") {
    //           q = "'" + selectionUtil.escSqlQuote(pair.value) + "'";
    //         } else {
    //           q = pair.value;
    //         }
    //         part = "("+pair.field+" = "+q+")";
    //       }
    //       if (parts.length > 0) parts += " AND ";
    //       parts += "("+part+")";
    //     }
    //   })
    // }
    // if (parts.length > 0) {
    //   if (where.length > 0) where += " AND ";
    //   where += "("+parts+")";
    // }

    let base = selectionUtil.getBaseDefinitionExpression(source && source.layer2D);
    let required = this.requiredExpression;
    if (base && base.length > 0) {
      if (required && required.length > 0) {
        base = "(("+required+") AND ("+base+"))";
      }
    } else if (required && required.length > 0) {
      base = required;
    }
    if (base && base.length > 0) {
      if (where && where.length > 0)  {
        where = "("+base+") AND ("+where+")";
      } else {
        where = base;
      }
    }

    if (where.length === 0) where = "1=1";
    return where;
  }

  newFilterPair(params) {
    let pair = {
      id: val.generateRandomId(),
      field: undefined,
      value: undefined
    };
    if (params) pair = Object.assign(pair,params);
    return pair;
  }

  onFilterPairsChanged(filterPairs) {
    this.filterPairs = filterPairs;
    this.where = this.makeWhere(this.getSource());
    Topic.publish(Topic.QueryCriteriaChanged,{key: this.key});
  }

  onSearchTextChanged(searchText) {
    this.searchText = searchText;
    this.where = this.makeWhere(this.getSource());
    Topic.publish(Topic.QueryCriteriaChanged,{key: this.key});
  }

  onSortChanged(sortOptions) {
    this.sortOptions = sortOptions;
    this.where = this.makeWhere(this.getSource());
    Topic.publish(Topic.QueryCriteriaChanged,{key: this.key});
  }

}
